import { render } from "./ProviderManagementPage.vue?vue&type=template&id=608c55e6&scoped=true"
import script from "./ProviderManagementPage.vue?vue&type=script&lang=js"
export * from "./ProviderManagementPage.vue?vue&type=script&lang=js"

import "./ProviderManagementPage.vue?vue&type=style&index=0&id=608c55e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608c55e6"]])

export default __exports__